// Clean whites (§11.11): amount, whole photo or only where painted.
import { Slider } from '../controls/Slider';
import { BrushControls, ToolButton } from './BrushControls';
import { useActive } from './useActive';
import { useUi } from '../../state/ui';
import { useT } from '../../i18n';

export function CleanWhitesPanel() {
  const t = useT();
  const { settings, update } = useActive();
  const brush = settings.cleanWhites.strokes !== null;
  return (
    <div>
      <div style={{ fontSize: 12, marginBottom: 6, opacity: 0.8 }}>{t('cleanWhitesHint')}</div>
      <Slider
        label="amount"
        testId="slider-cw-amount"
        value={settings.cleanWhites.amount}
        min={0}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.cleanWhites.amount = v), f)}
      />
      <div role="radiogroup" style={{ display: 'flex', gap: 4, margin: '6px 0' }}>
        {[false, true].map((b) => (
          <button
            key={String(b)}
            role="radio"
            aria-checked={brush === b}
            data-testid={b ? 'cw-brush' : 'cw-whole'}
            onClick={() => {
              update((s) => void (s.cleanWhites.strokes = b ? (s.cleanWhites.strokes ?? []) : null));
              if (!b && useUi.getState().tool === 'cleanWhites') useUi.getState().set({ tool: 'none' });
            }}
            style={brush === b ? { background: 'var(--accent-fill)', color: 'var(--on-accent)' } : undefined}
          >
            {t(b ? 'cleanWhitesBrush' : 'cleanWhitesWhole')}
          </button>
        ))}
      </div>
      {brush && (
        <>
          <ToolButton tool="cleanWhites" label={t('cleanWhitesTool')} testId="cw-tool" />
          <BrushControls />
        </>
      )}
    </div>
  );
}
